﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class CashMovement(
    val id: String = "",
    val tenant_id: String = "",
    val type: String, // "INCOME" or "EXPENSE"
    val amount: Double,
    val description: String? = null,
    val movement_date: String = "",
    val created_at: String = ""
)

